import { createSelector } from "reselect"


const customerArtisanFollowingListStateSelector = (state) => state.customerArtisanFollowingList

const customerArtisanFollowingListSelector = createSelector(
  [customerArtisanFollowingListStateSelector],
  (artisanFollowingList) => artisanFollowingList.items
)


export const customerArtisanFollowingListAsNameAndId = createSelector(
  [customerArtisanFollowingListSelector], 
  (products) => (
    products.map(({_id,businessName}) => ({
      _id,
      businessName
    })
  ))
)



export const customerArtisanFollowingListLoadingSelector = createSelector(
  [customerArtisanFollowingListStateSelector],
  (artisanFollowingList) => artisanFollowingList.isLoading
);

export const customerArtisanFollowingListCountSelector = createSelector(
  [customerArtisanFollowingListStateSelector],
  (artisanFollowingList) => artisanFollowingList.count
);

export const searchValueSelector = createSelector(
  [customerArtisanFollowingListStateSelector] , 
  artisanFollowingList => artisanFollowingList.searchValue
)